import { Box, Container } from "@mui/material";
import { Copyright } from "./Copyright";

export function Footer() {
  return (
    <Box
      component="footer"
      sx={(theme) => ({
        backgroundColor: theme.palette.brand.shell.background,
        borderTop: `1px solid ${theme.palette.brand.border}`,
        py: 2,
        color: theme.palette.brand.shell.text,
      })}
    >
      <Container maxWidth="lg">
        <Copyright />
      </Container>
    </Box>
  );
}
